import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthState } from '@app/core/states/auth.state';
import { Store } from '@ngxs/store';
import { createWidget } from '@typeform/embed';

@Component({
  selector: 'rk-santa-modal',
  templateUrl: './santa-modal.component.html',
  styleUrls: ['./santa-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SantaModalComponent implements AfterViewInit {
  completed = false;
  constructor(
    public readonly dialogRef: MatDialogRef<SantaModalComponent>,
    private readonly store: Store,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    const formId =
      this.store.selectSnapshot(AuthState.userLang).substr(0, 2) === 'fr'
        ? 'HLNttUgp'
        : 'oxzzCNJw';
    createWidget(formId, {
      container: document.querySelector('#form'),
      width: 480,
      height: 330,
      iframeProps: {
        style: 'width: 480px; height: 410px; border: 0; overflow: hidden;',
        scrolling: 'no',
      },
      onSubmit: () => {
        this.completed = true;
        this.cdr.detectChanges();
      },
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
